(function () {
  var root = document.getElementById('strikeman-home-final');
  if (!root) return;
  function trackHomepageEvent(name, payload) {
    if (window.StrikemanAnalytics && typeof window.StrikemanAnalytics.track === 'function') window.StrikemanAnalytics.track(name, payload);
  }
    var holidayCarousel = root.querySelector('[data-holiday-hero-experiment]');
    if (holidayCarousel) {
      var carouselControls = root.querySelector('template[id^="sf-holiday-carousel-controls-"]');
      holidayCarousel.appendChild(carouselControls.content.cloneNode(true));
      var holidaySlides = Array.from(holidayCarousel.querySelectorAll('[data-holiday-hero-variant]'));
      var holidaySlideIndex = 0;
      var holidayTimer;
      var holidayMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var holidayPaused = holidayMotion.matches;
      var holidayInView = true;
      var holidayTouchStart;
      var pauseControl = holidayCarousel.querySelector('[data-hero-pause]');
      function updateHolidayRotation() {
        window.clearTimeout(holidayTimer);
        pauseControl.setAttribute('aria-label', holidayPaused ? 'Play slideshow' : 'Pause slideshow');
        pauseControl.querySelector('[data-hero-pause-icon]').hidden = holidayPaused;
        pauseControl.querySelector('[data-hero-play-icon]').hidden = !holidayPaused;
        var slideHasFocus = holidaySlides.some(function (slide) { return slide.contains(document.activeElement); });
        if (!holidayPaused && holidayInView && !document.hidden && !slideHasFocus) {
          holidayTimer = window.setTimeout(function () { showHolidaySlide(holidaySlideIndex + 1); }, 5000);
        }
      }
      function showHolidaySlide(index) {
        holidaySlideIndex = (index + holidaySlides.length) % holidaySlides.length;
        holidaySlides.forEach(function (slide, slideIndex) {
          var active = slideIndex === holidaySlideIndex;
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-before', slideIndex < holidaySlideIndex);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        holidayCarousel.querySelectorAll('[data-hero-slide]').forEach(function (button) {
          button.setAttribute('aria-pressed', String(Number(button.dataset.heroSlide) === holidaySlideIndex));
        });
        updateHolidayRotation();
      }
      function manuallyShowHolidaySlide(index) {
        showHolidaySlide(index);
      }
      holidayCarousel.querySelectorAll('[data-hero-slide]').forEach(function (button) {
        button.addEventListener('click', function () { manuallyShowHolidaySlide(Number(button.dataset.heroSlide)); });
      });
      pauseControl.addEventListener('click', function () { holidayPaused = !holidayPaused; updateHolidayRotation(); });
      holidayCarousel.addEventListener('focusin', updateHolidayRotation);
      holidayCarousel.addEventListener('focusout', function () { window.setTimeout(updateHolidayRotation, 0); });
      holidayCarousel.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (!event.target.closest('.sf-holiday-hero__controls')) return;
        event.preventDefault();
        manuallyShowHolidaySlide(holidaySlideIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });
      holidayCarousel.addEventListener('touchstart', function (event) {
        holidayTouchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        window.clearTimeout(holidayTimer);
      }, { passive: true });
      holidayCarousel.addEventListener('touchend', function (event) {
        if (!holidayTouchStart) return;
        var dx = event.changedTouches[0].clientX - holidayTouchStart.x;
        var dy = event.changedTouches[0].clientY - holidayTouchStart.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) manuallyShowHolidaySlide(holidaySlideIndex + (dx < 0 ? 1 : -1));
        else updateHolidayRotation();
        holidayTouchStart = null;
      }, { passive: true });
      holidayCarousel.addEventListener('touchcancel', function () { holidayTouchStart = null; updateHolidayRotation(); }, { passive: true });
      document.addEventListener('visibilitychange', updateHolidayRotation);
      holidayMotion.addEventListener('change', function () { holidayPaused = holidayMotion.matches; updateHolidayRotation(); });
      if ('IntersectionObserver' in window) {
        var holidayObserver = new IntersectionObserver(function (entries) { holidayInView = entries[0].isIntersecting; updateHolidayRotation(); }, { threshold: 0.15 });
        holidayObserver.observe(holidayCarousel);
      }
      holidayCarousel.addEventListener('click', function (event) {
        var heroCta = event.target.closest('[data-holiday-hero-cta]');
        if (!heroCta || (window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main')) return;
        trackHomepageEvent('holiday_hero_cta_clicked', { surface: 'holiday_carousel', productName: holidaySlides[holidaySlideIndex].dataset.holidayHeroProduct, ctaType: heroCta.dataset.holidayHeroCta, destination: heroCta.getAttribute('href') });
      });
      showHolidaySlide(0);
    }

})();
